class Layer {
	id: number;
	name: string;
	visible: boolean;
	locked: boolean;
}

export default Layer;
